import axios from 'axios';

// Use environment variable or fallback to current origin in production
const getBaseURL = () => {
    // In production, API is served from same domain
    if (process.env.NODE_ENV === 'production') {
        return process.env.REACT_APP_API_URL || '';
    }
    // In development, use localhost
    return process.env.REACT_APP_API_URL || 'http://localhost:5000';
};

const instance = axios.create({
    baseURL: getBaseURL(),
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: true
});

// Token getter function - will be set by AxiosProvider
let getTokenFn = null;

export const setTokenGetter = (fn) => {
    getTokenFn = fn;
};

// Request interceptor that gets Clerk token
instance.interceptors.request.use(async (config) => {
    if (getTokenFn) {
        try {
            const token = await getTokenFn();
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
        } catch (error) {
            console.error('Error getting auth token:', error);
        }
    }
    return config;
});

export default instance;
